import { useMemo } from "react";
import { Provider } from "react-redux";
import AddOnsSupport from "./AddOnsSupport";

const AddOnsSupportApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <AddOnsSupport />
    </Provider>
  );
};

export default AddOnsSupportApp;
